export enum EmployeeReviewQuestionSetupLevel {
    global = 1,
    department = 2,
    team = 3
}